/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Sh_NumberInputs */



/**
* | output |
* | --- |
* | "SH #" |
*
* @param {Ccsl_Export_Header_Sh_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_sh_number = /** @type {((inputs?: Ccsl_Export_Header_Sh_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Sh_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("SH #")
	if (locale === "de") return /** @type {LocalizedString} */ ("SH #")
	if (locale === "it") return /** @type {LocalizedString} */ ("SH #")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ш #")
	if (locale === "es") return /** @type {LocalizedString} */ ("SH #")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SH #")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SH #")
	if (locale === "hi") return /** @type {LocalizedString} */ ("श #")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("SH #")
	return /** @type {LocalizedString} */ ("SH #")
});